export default "/images/vendor/flag-icon-css/flags/1x1/so.svg?34b037a702aae22a75340594821f0476";